export default "__VITE_ASSET__BVkyCRoH__"